import aws_exports from 'apps/alpha-coach-bot/src/aws-exports';

export const environment = {
  production: false,
  mode: 'development',
  sentryID: 'https://7a14caea54f94af1b011fa5893144a29@o4504227135291392.ingest.sentry.io/4504227149053952',
  productUrl: 'https://coachbot.gt.school/',
  launchDarklyKey: '61df22d9ccbc38143bd4c9fd',
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cloudfrontURL: 'https://dy4tqbwn657kc.cloudfront.net',
  aws_s3_students_assets_bucket: 'alpha-coach-bot-students-assets',
  activtrak_installer_mac:
    'https://gt-school-uploads.s3.amazonaws.com/activtrak-installer/ATMac638170_1EODbYcoqw8Y_35850289920.pkg',
  activtrak_installer_windows:
    'https://gt-school-uploads.s3.amazonaws.com/activtrak-installer/ATAcct638170_1EODbYcoqw8Y_7125952300.msi',
  aws_s3_students_assets_url: 'https://alpha-coach-bot-students-assets.s3.amazonaws.com/public',
  bootcampLeaderboardApiUrl: 'https://sheets.googleapis.com/v4/spreadsheets/',
  sheetId: '1w-4vIHieagWCk5ZKJsMvHqIpY-kaAh4jPKSqRqiBeFY',
  bootcampLeaderboardApiKey: 'AIzaSyAhvANeAZZwZd6klHMHbb631iupagJFtZ4',
  reportContentJSON: 'https://s3.amazonaws.com/coachbot.gtschool-assets-dev/covid-learning-loss-report/content.json',
  learningReportBucket: 'learning-loss-math-reports-dev',
  parentConsentApi: 'https://djqwupqcxioy4.cloudfront.net/data-collection-consent',
  parentConsentApiKey: '4LGm2heo00aCU44VISbng9GVRAXlR2byaK7lfKak',
  ...aws_exports,
};
